import typeToReducer from 'type-to-reducer';
import get from 'lodash.get';

import { RESET_STORE } from '../resetStore/actions';

import * as actions from './actions';
import { FavoritesStoreType } from './types';

export const initialState: FavoritesStoreType = {
  data: [],
  loading: true,
  err: false,
  errMsg: '',
};

export default typeToReducer(
  {
    [actions.GET_FAVORITES]: {
      PENDING: (state: FavoritesStoreType): FavoritesStoreType => ({
        ...state,
        loading: true,
      }),
      FULFILLED: (_: FavoritesStoreType, action): FavoritesStoreType => {
        const data = get(action, 'payload.data', []) ?? [];

        return {
          ...initialState,
          loading: false,
          data,
        };
      },
      REJECTED: (state: FavoritesStoreType, action): FavoritesStoreType => ({
        ...state,
        loading: false,
        err: true,
        errMsg: action.payload.message,
      }),
    },

    [actions.UPDATE_FAVORITES]: (state: FavoritesStoreType, action): FavoritesStoreType => {
      const { asset, metricCode } = action.payload;
      const filtered = state.data.filter((item) => {
        if (item.asset === asset && item.metricCode === metricCode) {
          return false;
        }

        return true;
      });

      if (state.data.length === filtered.length) {
        const data = [...state.data, { asset, metricCode }];

        return {
          ...state,
          data,
        };
      }

      return {
        ...state,
        data: filtered,
      };
    },

    [RESET_STORE]: (): FavoritesStoreType => initialState,
  },
  initialState,
);
